import axios from '../../../helpers/custom-axios';
import { notify } from '../../../helpers/notifications';

export const handleSortUpdate = async (model, id, sort) => {
  return axios
    .put(`manage/${model}/${id}`, { sort })
    .then((res) => {
      notify.saved();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};
